import { render } from "./entity_documents.html?vue&type=template&id=0b057ec9&scoped=true&external"
import script from "./entity_documents.js?vue&type=script&lang=js&external"
export * from "./entity_documents.js?vue&type=script&lang=js&external"

import "./EntityDocuments.vue?vue&type=style&index=0&id=0b057ec9&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b057ec9"]])

export default __exports__